module.exports = __webpack_public_path__ + "img/hr-brown-fluff-12.03718abd.png";